module.exports = "<mat-list>\n\t<mat-list-item *ngFor=\"let item of data.list\" [innerHTML]=\"item\"></mat-list-item>\n</mat-list>"